import { stylesheet } from 'astroturf';
import { FunctionalComponent } from 'preact';
import { StandardCard } from '../ShowPage/StandardCard';
import { StandardCarouselItem } from './types';

const TILE_WIDTH_PX = 225;

const styles = stylesheet`
  @import '##/styles/import.scss';

  .card-title {
    margin-top: pxToVh(10);
    font-size: 1.64rem;
    line-height: pxToVh(20);
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
    display: -webkit-box;
    height: pxToVh(22);
    overflow: hidden;
  }

  .card-subtitle {
    font-size: 1.35rem;
    margin-top: pxToVh(6);
    opacity: 1;
    color: $secondary-grey;
    line-height: pxToVh(17);
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
    display: -webkit-box;
    height: pxToVh(17.5);
    overflow: hidden;
  }

  .carousel-item {
    position: relative;
    width: pxToVw(${TILE_WIDTH_PX});
    height: pxToVh(200);
    margin-right: pxToVw(20);
    font-family: barlow;
    flex-shrink: 0;
  }
`;

const StandardCarouselTile: FunctionalComponent<StandardCarouselItem & {
  isInbound?: boolean;
  domId: string;
}> = (props) => {
  if (props.isInbound === false) {
    return <div id={props.domId} className={styles.carouselItem} />;
  }
  return (
    <div className={styles.carouselItem} id={props.domId}>
      <StandardCard {...Object.assign(props, { tileWidthPx: TILE_WIDTH_PX })} />
      {props.title && <div className={styles.cardTitle}>{props.title}</div>}
      {props.description && (
        <div className={styles.cardSubtitle}>{props.description}</div>
      )}
    </div>
  );
};

export default StandardCarouselTile;
